import React, { useCallback, useState } from 'react'
import SafeCharegePage from './safecharge'
import StripePage from './stripe'
import Ebanx from './ebanx'

import * as PayMethods from '../../../../../../utils/paymethods'
import Cache from '../../../../../../utils/cache'
import CardList from '../fragments/card-list'

import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Box, Boxes } from '../../../layout/box'

export default props => {
    useStyles(classes)
    const { payMethod, cardList } = props
    const [showNew, setShowNew] = useState(!(cardList?.length > 0))

    let CreditPage
    switch (payMethod) {
        case PayMethods.__Pay_Method_Stripe__:
        case PayMethods.__Pay_Method_Stripe_EU__:
        case PayMethods.__Pay_Method_Stripe_GB__:
        case PayMethods.__Pay_Method_Stripe_IR__:
            CreditPage = StripePage
            break
        case PayMethods.__Pay_Method_SafeCharge__:
            CreditPage = SafeCharegePage
            break
        case PayMethods.__Pay_Ebanx__:
        case PayMethods.__Pay_Ebanx_Debet__:    
            CreditPage = Ebanx
            break    
        default:
            break
    }

    const trackPayOrder = useCallback(() => {
        // try {
        //     const count = Cache.get('credit-pay-count') || 1
        //     if (window.GeekoSensors) {
        //         window.GeekoSensors.Track('PayOrder', {
        //             pay_method: payMethod,
        //             pay_now: count
        //         })
        //         Cache.set('credit-pay-count', count + 1)
        //     }
        // } catch (e) {
        //     console.error(e)
        // }
    }, [])


    return <>
        <Boxes>
            <Box className={classes.CardListContainer}>
                <div className={classes.CreditImage}>
                    <img src={`https://image.geeko.ltd/upgrade/20210713/credit.jpg`} />
                </div>
                {
                    props.cardList?.length > 0 && <CardList selectCardHandle={props.selectCardHandle} cardList={props.cardList} showNewHandle={setShowNew} showNew={showNew}/>
                }
            </Box>
        </Boxes>

        

        <CreditPage {...props} showNew={showNew} trackPayOrder={trackPayOrder} />
        
    </>
}